import type { IconNode } from '../types';

/**
 * @name candle-holder-lit
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTAgMlM4IDMuOSA4IDVzLjkgMiAyIDIgMi0uOSAyLTItMi0zLTItMyIgLz4KICA8cmVjdCB3aWR0aD0iNCIgaGVpZ2h0PSI3IiB4PSI4IiB5PSIxMSIgLz4KICA8cGF0aCBkPSJtMTMgMTMtMS0yIiAvPgogIDxwYXRoIGQ9Ik0xOCAxOGE0IDQgMCAwIDEtNCA0SDZhNCA0IDAgMCAxLTQtNGgxOGEyIDIgMCAxIDAtMi0yWiIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/candle-holder-lit
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const candleHolderLit: IconNode = [
  ['path', { d: 'M10 2S8 3.9 8 5s.9 2 2 2 2-.9 2-2-2-3-2-3', key: '1e8l08' }],
  ['rect', { width: '4', height: '7', x: '8', y: '11', key: '11vyao' }],
  ['path', { d: 'm13 13-1-2', key: 'osfrzo' }],
  ['path', { d: 'M18 18a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4h18a2 2 0 1 0-2-2Z', key: '13174f' }],
];

export default candleHolderLit;
